
export default {
	name: 'TransitionWrapper',

	inheritAttrs: false,

	props: {
		name: {
			type: String,
			default: undefined,
			validator(value) {
				return [
					'fade',
					'radial-reveal',
					'slide-up',
					'slide-right',
					'slide-down',
					'toast',
					'zoom',
				].includes(value)
			},
		},

		group: {
			type: Boolean,
			default: false,
		},
	},
}
